// extracted by mini-css-extract-plugin
export default {"accordion-list":"Dw2QAz","accordion-list__content":"brvV4E","accordion-list__media":"mBxOIX"};